/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  ASSET_LIST_SUCCESS,
  ASSET_LIST_FAILURE,
  RESET_ASSET_LIST,
} from "../actions/asset/assetActionTypes";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case ASSET_LIST_SUCCESS:
      return {
        data: action.payload.data,
        getAssetListSuccess: true,
      };
    case ASSET_LIST_FAILURE:
      return {
        getAssetListSuccess: false,
        error: action.err.message,
      };

    case RESET_ASSET_LIST:
      return {};
    default:
      return state;
  }
}
